<template>
  <SettingsSection>
    <div class="settingsAreaPassword">
      <div class="settingsAreaPassword__section">
        <div class="settingsAreaPassword__section__container">
          <div class="settingsAreaPassword__section__label">Current password</div>
          <input type="password" class="settingsAreaPassword__section__input" placeholder="************" v-model="oldPassword" />
          <div class="password-error" v-if="oldPasswordError">
            {{ oldPasswordErrorMessage }}
          </div>
        </div>
      </div>
      <div class="settingsAreaPassword__separator"></div>
      <div class="settingsAreaPassword__section">
        <div class="settingsAreaPassword__section__container" style="margin-bottom: 20px">
          <div class="settingsAreaPassword__section__label">Enter new password</div>
          <input type="password" class="settingsAreaPassword__section__input" placeholder="************" v-model="newPassword" />
          <div class="settingsAreaPassword__section__error" v-if="newPasswordError">
            {{ newPasswordErrorMessage }}
          </div>
        </div>
        <div class="settingsAreaPassword__section__container">
          <div class="settingsAreaPassword__section__label">Confirm new password</div>
          <input type="password" class="settingsAreaPassword__section__input" placeholder="************" v-model="newPasswordConfirmation" />
          <div class="settingsAreaPassword__section__error" v-if="newPasswordConfirmationError">
            {{ newPasswordConfirmationErrorMessage }}
          </div>
        </div>
      </div>
    </div>
    <div class="settingsAreaPassword__section__result" v-if="generalPasswordError">
      {{ generalPasswordErrorMessage }}
    </div>
    <div class="settingsAreaPassword__section__result" v-if="passwordChangeSuccess">
      {{ passwordChangeSuccessMessage }}
    </div>
    <div class="settingsAreaPassword__save__button" @click="changePassword" :disabled="changingPassword">
      {{ changingPassword ? "Saving..." : "Change password" }}
    </div>
  </SettingsSection>
</template>

<script>
import { requestWithAuthentication } from "../../config/api";
import { mapState } from "vuex";
import SettingsSection from "./SettingsSection.vue";

function initialState() {
  return {
    changingPassword: false,
    oldPassword: "",
    newPassword: "",
    newPasswordConfirmation: "",
    oldPasswordError: false,
    newPasswordError: false,
    newPasswordConfirmationError: false,
    oldPasswordErrorMessage: "",
    newPasswordErrorMessage: "",
    newPasswordConfirmationErrorMessage: "",
    generalPasswordError: false,
    generalPasswordErrorMessage: "",
    passwordChangeSuccess: false,
    passwordChangeSuccessMessage: "",
  };
}

export default {
  name: "ChangePassword",
  data: function () {
    return initialState();
  },
  components: {
    SettingsSection,
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
  },
  methods: {
    resetData: function () {
      Object.assign(this.$data, initialState());
    },
    async changePassword() {
      let passwordChangeData = {
        oldPassword: this.oldPassword,
        newPassword: this.newPassword,
        newPasswordConfirmation: this.newPasswordConfirmation,
        userId: this.user._id,
      };

      this.changingPassword = true;

      let passwordErrorState = this.runInitialValidation();
      if (passwordErrorState) {
        this.changingPassword = false;
        return;
      }

      try {
        const result = await requestWithAuthentication(`post`, "/api/settings/changePassword", passwordChangeData);

        if (result.data.success) {
          this.resetData();
          this.passwordChangeSuccess = true;
          this.passwordChangeSuccessMessage = "Password successfully changed.";
          let globalThis = this;
          setTimeout(function () {
            globalThis.passwordChangeSuccess = false;
            globalThis.passwordChangeSuccessMessage = "";
          }, 5000);
        }
      } catch ({ response }) {
        if (response.data.errors) {
          this.processAndDisplayServerErrors(response.data.errors);
        } else {
          let errors = {
            didNotReceiveResponseBack: true,
          };
          this.processAndDisplayServerErrors(errors);
        }
        this.changingPassword = false;
      }
    },
    runInitialValidation() {
      let passwordError = false;

      this.oldPasswordError = false;
      this.newPasswordError = false;
      this.newPasswordConfirmationError = false;

      this.oldPasswordErrorMessage = "";
      this.newPasswordErrorMessage = "";
      this.newPasswordConfirmationErrorMessage = "";

      if (!this.oldPassword) {
        this.oldPasswordError = true;
        this.oldPasswordErrorMessage = "Cannot be empty!";
        passwordError = true;
      }

      if (this.newPassword.length < 8) {
        this.newPasswordError = true;
        this.newPasswordErrorMessage = "Password must be at least 8 characters long";
        passwordError = true;
      }

      if (!this.newPassword) {
        this.newPasswordError = true;
        this.newPasswordErrorMessage = "Cannot be empty!";
        passwordError = true;
      }

      if (!this.newPasswordConfirmation) {
        this.newPasswordConfirmationError = true;
        this.newPasswordConfirmationErrorMessage = "Cannot be empty!";
        passwordError = true;
      }

      if (this.newPassword && this.newPasswordConfirmation && this.newPassword !== this.newPasswordConfirmation) {
        this.newPasswordConfirmationError = false;
        this.newPasswordConfirmationErrorMessage = "";
        this.newPasswordError = true;
        this.newPasswordErrorMessage = "Passwords don't match!";
        passwordError = true;
      }

      return passwordError;
    },
    processAndDisplayServerErrors(errors) {
      //   If fail: { errors: UserIdMissing
      //                      OldPasswordMissing
      //                      NewPasswordMissing
      //                      NewPasswordConfirmationMissing
      //                      PasswordsDoNotMatch
      //                      FailedToChangePassword
      //                      IncorrectPassword
      //                      ExceptionError }
      console.log("@processServerError: ", errors);
      this.generalPasswordError = false;
      this.generalPasswordErrorMessage = "";

      if (!errors) {
        console.warn("Threw error but no errors. Ehhh...");
        return;
      } else if (errors.didNotReceiveResponseBack) {
        this.generalPasswordError = true;
        this.generalPasswordErrorMessage = "Network error. Please refresh and try again.";
      } else if (errors) {
        this.generalPasswordError = true;

        if (errors.OldPasswordMissing) {
          this.oldPasswordError = true;
          this.oldPasswordErrorMessage = "Must provide old password!";
        }

        if (errors.NewPasswordMissing) {
          this.newPasswordError = true;
          this.newPasswordErrorMessage = "New password missing!";
        }

        if (errors.NewPasswordConfirmationMissing) {
          this.newPasswordConfirmationError = true;
          this.newPasswordConfirmationErrorMessage = "New password confirmation missing!";
        }

        if (errors.PasswordsDoNotMatch) {
          this.generalPasswordError = true;
          this.generalPasswordErrorMessage = "Passwords don't match!";
        }

        if (errors.FailedToChangePassword || errors.ExceptionError) {
          this.generalPasswordError = true;
          this.generalPasswordErrorMessage = "Failed to change password. Try again or contact support";
        }

        if (errors.IncorrectPassword) {
          this.generalPasswordError = true;
          this.generalPasswordErrorMessage = "Password incorrect!";
        }
      }
    },
  },
};
</script>

<style scoped>
.settingsAreaPassword__section {
  display: flex;
  flex-direction: column;
}
.settingsAreaPassword__separator {
  border-bottom: 1px solid #eaeaea;
  margin: 25px auto;
  width: 100%;
}
.settingsAreaPassword__section__label {
  margin-bottom: 10px;
  text-wrap: nowrap;
  color: #333;
}
.settingsAreaPassword__section__input {
  border: 1px solid #eee;
  border-radius: 12px;
  width: 100%;
  caret-color: #666;
  padding: 8px 12px;
  font-size: 16px;
  font-family: "Nunito", sans-serif;
  transition: 0.2s ease;
  box-sizing: border-box;
  outline: none;
}
.settingsAreaPassword__section__input:hover {
  border-color: #ccc;
}
.settingsAreaPassword__section__input:focus {
  border-color: #ccc;
}
.settingsAreaPassword__save__button {
  padding: 10px 15px;
  font-weight: 500;
  background-color: #333;
  border-radius: 360px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: white;
  font-size: 16px;
  width: fit-content;
  margin-top: 20px;
  margin-left: auto;
  box-sizing: border-box;
  width: 161px;
}
.settingsAreaPassword__save__button:hover {
  background-color: var(--button-color-hover);
}
.settingsAreaPassword__section__error {
  color: #333;
  background-color: #f9f9f9;
  padding: 10px 15px;
  border-radius: 360px;
  font-size: 14px;
  box-sizing: border-box;
  text-align: center;
  font-weight: 600;
  margin-top: 10px;
}
.settingsAreaPassword__section__result {
  color: #333;
  background-color: #f9f9f9;
  padding: 10px 15px;
  border-radius: 360px;
  font-size: 16px;
  box-sizing: border-box;
  text-align: center;
  font-weight: 600;
  margin-top: 20px;
}
</style>
